import React from 'react';

const lokeshImg = 'images/lokesh_chandra_ascend_capital.jpg';
const gauravImg = 'images/gaurav.jpg';

const members = [
  {
    img: lokeshImg,
    name: 'Lokesh Chandra, CFA',
    role: 'Founder',
    bio: 'Lokesh has around 7 years of expertise in mortgage, credit and risk management. Most recently, he worked as a RMO and HECM trader for KGS-Alpha Capital Markets and Barclays US office. Lokesh graduated from IIT Madras with a B.Tech & M.Tech in Electrical Engineering and completed his MBA in Finance from IIM Calcutta.',
  },
  {
    img: gauravImg,
    name: 'Gaurav Maheshwari',
    role: 'Founder',
    bio: 'Gaurav has around 8 years of experience in credit and market risk models in banking and finance industry (HSBC and Citi). He has around 10 years of expertise in product management and creating scalable web and mobile applications from scratch. Prior to Ascend Capital, he was responsible for product management and technology stack of PrettySecrets online platform. Gaurav graduated from IIT Madras with BTech. in Electrical Engineering.',
  },
];

export default class Team extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selected: null,
    };
  }

  handleClick = (i) => {
    this.setState({ open: true, selected: i });
  };

  handleClose = () => {
    this.setState({ open: false, selected: null });
  };

  render() {
    const { open, selected } = this.state;
    const member = selected !== null ? members[selected] : null;

    return (
      <div id="team" style={{ background: 'var(--dark-bg, #0F0C29)', padding: '48px 16px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <div className="section-title text-center" style={{ marginBottom: 36 }}>
            <h3 style={{ color: '#fff', fontSize: 32, fontWeight: 700 }}>Core Team</h3>
          </div>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 24,
          }}>
            {members.map((m, i) => (
              <div
                key={i}
                onClick={() => this.handleClick(i)}
                style={{
                  background: 'rgba(30,26,61,0.9)',
                  border: '1px solid rgba(199,125,204,0.2)',
                  borderRadius: 20,
                  padding: '32px 28px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  width: 220,
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(0,0,0,0.45)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.3)'; }}
              >
                <img
                  src={m.img}
                  alt={m.name}
                  style={{
                    width: 140,
                    height: 140,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid rgba(199,125,204,0.5)',
                    marginBottom: 18,
                  }}
                />
                <div style={{ color: '#fff', fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 6 }}>{m.name}</div>
                <div style={{ color: '#c77dcc', fontSize: 13, fontWeight: 500, letterSpacing: '0.5px' }}>{m.role}</div>
                <div style={{ color: '#7F77DD', fontSize: 12, marginTop: 14 }}>View Profile →</div>
              </div>
            ))}
          </div>
        </div>

        {/* Bio Modal */}
        {open && member && (
          <div
            onClick={this.handleClose}
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0,0,0,0.7)',
              backdropFilter: 'blur(4px)',
              zIndex: 1200,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 16,
            }}
          >
            <div
              onClick={e => e.stopPropagation()}
              style={{
                background: 'linear-gradient(135deg, #1a1650 0%, #0f0c29 100%)',
                border: '1px solid rgba(199,125,204,0.25)',
                borderRadius: 20,
                padding: '40px 36px',
                maxWidth: 480,
                width: '100%',
                boxShadow: '0 24px 64px rgba(0,0,0,0.6)',
                position: 'relative',
              }}
            >
              {/* Close button */}
              <button
                onClick={this.handleClose}
                style={{
                  position: 'absolute',
                  top: 16,
                  right: 20,
                  background: 'none',
                  border: 'none',
                  color: '#AFA9EC',
                  fontSize: 22,
                  cursor: 'pointer',
                  lineHeight: 1,
                  padding: 4,
                }}
              >
                ✕
              </button>

              {/* Photo + name */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 24 }}>
                <img
                  src={member.img}
                  alt={member.name}
                  style={{
                    width: 90,
                    height: 90,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid rgba(199,125,204,0.5)',
                    flexShrink: 0,
                  }}
                />
                <div>
                  <div style={{ color: '#EEEDFE', fontWeight: 700, fontSize: 18, marginBottom: 4 }}>{member.name}</div>
                  <div style={{
                    display: 'inline-block',
                    background: 'rgba(83,74,183,0.3)',
                    border: '1px solid rgba(127,119,221,0.4)',
                    borderRadius: 20,
                    padding: '2px 12px',
                    color: '#7F77DD',
                    fontSize: 12,
                    fontWeight: 500,
                    letterSpacing: '0.5px',
                  }}>{member.role}</div>
                </div>
              </div>

              {/* Divider */}
              <div style={{ height: 1, background: 'rgba(83,74,183,0.3)', marginBottom: 20 }} />

              {/* Bio */}
              <p style={{ color: '#AFA9EC', fontSize: 14, lineHeight: 1.7, margin: 0 }}>
                {member.bio}
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Team.js